module.exports = __webpack_public_path__ + "static/media/shape3.6d2d33ec.svg";